// define this week reducers.
import { replaceUScoreWithSpace } from '../utils/common';
import MyworkConst from '../constants/this_week.constants';

const MyworkDetailsReducer = (state = {}, action) => {
   //console.log("MyworkDetailsReducer", state);
  const initialState = state;
  switch (action.type) {
    case MyworkConst.MYWORK_AI_NEW:
      if (Object.keys(action.value).length) {
        initialState.dateArr[action.value.list].unshift(action.value);
        state = { ...state, initialState };
      }
      break;
    case MyworkConst.MYWORK_AI_UPDATE:
      initialState.dateArr[action.key] = initialState.dateArr[action.key].map((item) => {
        if (item.id == action.id) {
          item = Object.assign({}, item, action.value);
        }
        return item;
      });
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_FILTER_ID:
      initialState.thisWeekAiPref = action.id;
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_FILTER_AI:
      if (action.filterId == 0) {
        Object.keys(initialState.dateArr).map((dataAiList) => {
          (initialState.dateArr[dataAiList]).map((items) => {
            if (Object.keys(items).length > 0) {
              return initialState.dateArr[dataAiList] = initialState.dateArr[dataAiList].filter(t => t.parent == null);
            }
          });
          initialState.dateArr[dataAiList];
        });
      } else {
        initialState.aryData;
      }
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_STATUS_AI:
      if (action.state == 0 && action.fromWs == 0) {
        aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
          (initialState.dateArr[dataAiList]).map((items) => {
            if (Object.keys(items).length > 0 && action.actID != '') {
              return initialState.dateArr[dataAiList] = (initialState.dateArr[dataAiList]).filter(t => t.id != action.actID);
            }
          });
          return initialState.dateArr;
        });
      } else {
        aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
          (initialState.dateArr[dataAiList]).map((items) => {
            if (Object.keys(items).length > 0 && action.actID == items.id) {
              items.state = action.state;
            }
            return items;
          });
          return initialState.dateArr;
        });
      }

      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_EFFORT_AI:
      aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
        (initialState.dateArr[dataAiList]).map((items) => {
          if (Object.keys(items).length > 0 && action.actID == items.id) {
            items.effort = action.effort;
          }
          return items;
        });
        return initialState.dateArr;
      });
      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_RATING_AI:
      aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
        (initialState.dateArr[dataAiList]).map((items) => {
          if (Object.keys(items).length > 0 && action.actID == items.id) {
            items.rag = action.rag;
          }
          return items;
        });
        return initialState.dateArr;
      });
      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_PRIORITY_AI:
      aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
        (initialState.dateArr[dataAiList]).map((items) => {
          if (Object.keys(items).length > 0 && action.actID == items.id) {
            items.priority = action.priority;
          }
          return items;
        });
        return initialState.dateArr;
      });
      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_START_DATE_AI:
      // console.log('MYWORK_START_DATE_AI Update---> For Action Item id --->' + action.actID);
      var timeStampDate = new Date(action.start_date).getTime() / 1000;
      aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
        (initialState.dateArr[dataAiList]).map((items) => {
          if (Object.keys(items).length > 0 && action.actID == items.id) {
            items.start_date = timeStampDate;
          }
          return items;
        });
        return initialState.dateArr;
      });
      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_END_DATE_AI:
      // console.log('MYWORK_END_DATE_AI Update---> For Action Item id --->' + action.due_date);
      var timeStampDate = new Date(action.due_date).getTime() / 1000;
      var dataThisWeekAiList = '';
      if (action.calView == 'month') {
        dataThisWeekAiList = action.monthWeek;
      } else {
        dataThisWeekAiList = moment.utc(action.due_date, 'MMM DD, YYYY').format('YYYY-MM-DD');
      }

      if (action.calView == 'month') {
        var epoch = moment.utc(`${action.due_date} 00:00:00`).unix();
      } else {
        var epoch = moment.utc(`${dataThisWeekAiList} 00:00:00`).unix();
      }

      var newTempArr = [];
      var newTempArr1 = {};
      var aiListArray = {};
      initialState.dateArr = Object.keys(initialState.dateArr).map((dataAiList) => {
        newTempArr1 = (initialState.dateArr[dataAiList]).filter(t => t.id == action.actID);
        if (newTempArr1 != undefined && newTempArr1 != null && newTempArr1.length > 0) {
          (newTempArr1).map((items) => {
            if (Object.keys(items).length > 0 && action.actID == items.id) {
              items.due_date = epoch;
            }
            newTempArr = items;
            return items;
          });
        }
        return initialState.dateArr;
      });
      aiListArray = Object.keys(initialState.dateArr[0]).map((dataAiList) => {
        if (dataAiList == dataThisWeekAiList) {
          // console.log(dataAiList + '----' + dataThisWeekAiList);
          initialState.dateArr[0][dataAiList] = (initialState.dateArr[0][dataAiList]).concat(newTempArr);
        } else {
          initialState.dateArr[0][dataAiList] = (initialState.dateArr[0][dataAiList]).filter(t => t.id != action.actID);
        }
        return initialState.dateArr[0];
      });
      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_REMINDER_AI:
      aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
        (initialState.dateArr[dataAiList]).map((items) => {
          if (Object.keys(items).length > 0 && action.actID == items.id) {
            items.reminderData = action.reminderData;
          }
          return items;
        });
        return initialState.dateArr;
      });
      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_DELETE_AI:
      aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
        (initialState.dateArr[dataAiList]).map((items) => {
          if (Object.keys(items).length > 0 && action.actID != '') {
            return initialState.dateArr[dataAiList] = (initialState.dateArr[dataAiList]).filter(t => t.id != action.actID);
          }
        });
        return initialState.dateArr;
      });
      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_DELEGATE_AI:
      aiListArray = Object.keys(initialState.dateArr).map((dataAiList) => {
        (initialState.dateArr[dataAiList]).map((items) => {
          if (Object.keys(items).length > 0 && action.actID != '') {
            return initialState.dateArr[dataAiList] = (initialState.dateArr[dataAiList]).filter(t => t.id != action.actID);
          }
        });
        return initialState.dateArr;
      });
      initialState.dateArr = aiListArray[0];
      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_AI_DRAG_DROP:
      var timeStampDate = new Date(action.value.due_date).getTime() / 1000;
      var dataThisWeekAiList = moment.utc(action.value.due_date * 1000).format('YYYY-MM-DD');
      var senderDueDate = moment.utc(action.value.prevDate * 1000).format('YYYY-MM-DD');
      var newTempArr1 = {};
      newTempArr1 = initialState.dateArr[senderDueDate].find(i => i.id == action.value.actID);
      initialState.dateArr[senderDueDate] = initialState.dateArr[senderDueDate].filter(it => it.id != action.value.actID);
      if (newTempArr1) {
        newTempArr1 = Object.assign({}, newTempArr1, { due_date: action.value.due_date });
        if (typeof initialState.dateArr[dataThisWeekAiList] !== 'undefined' && initialState.dateArr[dataThisWeekAiList]) {
          initialState.dateArr[dataThisWeekAiList].splice(action.value.positionIndex, 0, newTempArr1);
        }
      }

      // update sorting order
      const senderKey = replaceUScoreWithSpace(`col_sorting_${senderDueDate}`);
      if (typeof initialState.sorting[senderKey] !== 'undefined' && initialState.sorting[senderKey]) {
        initialState.sorting[senderKey] = initialState.sorting[senderKey].filter(it => it != action.value.actID);
      }

      const receiverKey = replaceUScoreWithSpace(`col_sorting_${dataThisWeekAiList}`);
      if (typeof initialState.sorting[receiverKey] !== 'undefined' && initialState.sorting[receiverKey]) {
        initialState.sorting[receiverKey].splice(action.value.positionIndex, 0, action.value.actID);
      } else {
        let aiArr = [];
        initialState.dateArr[dataThisWeekAiList].map((it) => {
          aiArr = aiArr.concat(it.id);
        });
        initialState.sorting[receiverKey] = aiArr;
      }

      state = { ...state, initialState };
      break;
    case MyworkConst.MYWORK_RELOAD_DATA:
      state = action.data;
    default:
      break;
  }
  return state;
};

export default MyworkDetailsReducer;
